/* @jsx h */
import { defineComponent, h, ref } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";
import type { StockItem, StockUnit } from "./types";
import { UnitsEditor, validUnits } from "./UnitsEditor";

type Props = {
  item: StockItem;
  saving: boolean;
  onClose: () => void;
  onSave: (units: StockUnit[]) => void;
};

export const EditUnitsModal = defineComponent<Props>({
  name: "EditUnitsModal",
  props: ["item", "saving", "onClose", "onSave"],
  setup(props) {
    const { t } = useLocalization();
    const units = ref<StockUnit[]>(
      props.item.units.map((u) => ({ name: u.name, base_qty: u.base_qty })),
    );

    return () => (
      <LemmonModal
        title={t("inventory.stock.units_title").replace("{name}", props.item.name)}
        onClose={props.onClose}
        renderButtons={() => (
          <div class="border-t p-4">
            <div class="flex justify-between gap-2">
              <button class="btn btn-neutral" onClick={() => props.onClose()}>
                {t("general.words.cancel")}
              </button>
              <button
                class="btn btn-primary"
                disabled={props.saving}
                onClick={() => props.onSave(validUnits(units.value))}
              >
                {t("general.words.save")}
              </button>
            </div>
          </div>
        )}
      >
        <div class="space-y-3 p-6">
          <p class="text-sm text-base-content/60">{t("inventory.stock.units_help")}</p>
          <UnitsEditor
            baseUnit={props.item.base_unit}
            units={units.value}
            onChange={(next: StockUnit[]) => (units.value = next)}
          />
        </div>
      </LemmonModal>
    );
  },
});
